/* eslint-disable jira/filename-case */
export const TASK_SUCCESS = 'taskSuccess' as const;
export const TASK_FAIL = 'taskFail' as const;
export const TASK_ABORT = 'taskAbort' as const;

export type Action = typeof TASK_SUCCESS | typeof TASK_ABORT | typeof TASK_FAIL;
